const d = 'M400-80 0-480l400-400 56 57-343 343 343 343-56 57Z';

export default d;
